<template>
  <div>
    <div class="label_lyric_choose">
      <label class="formulate-input-label red-text-label"
        >* Please choose your favorite lyrics</label
      >
    </div>
    <div class="Abn_box_form_lyrics">
      <button
        type="button"
        @click="ShowBoxSearchLyric"
        class="btn btn-search-lyric"
        v-bind:class="{ choose_lyric_active: ChooseLyricActive }"
      >
        <v-icon class="v-ion-abn" name="music"></v-icon> Search Lyrics
      </button>
    </div>

    <div v-if="this.BoxcontentMessageError" class="message-error-left-group">
      <div>{{ contentMessageError }}</div>
    </div>

    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="90%"
      :max-width="500"
      :min-width="300"
      :clickToClose="true"
      :reset="true"
      style="max-width: 90vw"
    >
      <div class="Abn-modal-content">
        <div class="Abn-modal-header">
          <h6 class="Abn-modal-title">Find your song</h6>
        </div>
        <div class="Abn-modal-body">
          <div v-if="!this.OnLyric" class="Abn-choose-lyric">
            <div>
              <p class="modal-body-header-title2">Type any song phrase (*):</p>
            </div>
            <div class="box-search-song">
              <input
                type="search"
                v-on:keyup.enter="() => changeSelect()"
                v-model="defaultSelectText"
                class="form-select-search-lyric form-control"
                placeholder="Search lyrics..."
              />
              <div
                class="btn-icon-search-lyric"
                @click="() => changeSelect()"
                v-bind:class="{
                  disabled: searchLoading || defaultSelectText == ''
                }"
              >
                <font-awesome-icon
                  v-if="searchLoading"
                  :icon="['fas', 'spinner']"
                  class="fa-spin"
                  style="font-size: 18px;"
                />
                <v-icon v-else name="search" style="width: 18px;" />
              </div>
            </div>
            <div class="loading_Skeleton" v-if="searchLoading">
              <skeleton />
            </div>
            <ul
              v-if="!searchLoading && dropdownData.length > 1"
              class="list_track_group"
            >
              <li
                class="list_track_item"
                :data-id-name="item.id"
                v-for="item in dropdownData"
                :key="item.id"
              >
                <input
                  required
                  @input="GetDataItemSong"
                  :data-artist-name="item.artist_name"
                  :data-name="item.name"
                  type="radio"
                  :id="item.path"
                  v-model="trackItem"
                  name="track_item"
                  :value="`${item.name}&&${item.artist_name}`"
                />
                <label :for="item.path"
                  >{{ item.name }} - {{ item.artist_name }}</label
                >
              </li>
            </ul>
          </div>

          <div v-if="this.OnLyric" class="Abn-show-lyric">
            <label class="Abn-admin_name_lyric" for="name_lyric">{{
              this.SongDataName
            }}</label>
            <textarea
              id="name_lyric"
              required
              class="form-control Abn-lyric-text"
              v-model="LyricMusic"
              rows="5"
            ></textarea>
          </div>
        </div>
        <div class="Abn-modal-footer">
          <button
            type="button"
            v-if="this.OnLyric"
            @click="ButtonApllyPrev"
            class="btn Abn-btn-cancel"
          >
            Prev
          </button>
          <button
            type="button"
            v-if="this.OnLyric"
            class="btn Abn-btn-apply"
            @click="changeImageOnbutton"
          >
            Apply
          </button>
          <button
            type="button"
            v-if="!this.OnLyric"
            @click="hideSearchLyrics"
            class="btn Abn-btn-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            v-if="!this.OnLyric"
            @click="ButtonApllyNext"
            class="btn Abn-btn-apply"
          >
            Next
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import jQuery from 'jquery'
import {
  ASSET_URL,
  URL_API_IMAGE_LYRIC,
  URL_API_SEARCH_LYRIC
} from '@/config.js'
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'
import Skeleton from '../Utilities/Skeleton'
import { get } from 'lodash'
import { URL_API_NEW_SEARCH_LRCLIB, URL_API_NEW_SEARCH_LYRIC } from '../../config'

export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    colortextlyrics: {
      type: String,
      default: '#000000'
    },
    shapes: {
      type: String,
      default: ''
    },
    fontfamilyurl: {
      type: String,
      default: null
    },
    lyricIdParent: {
      type: String,
      default: null
    }
  },
  components: {
    Skeleton
  },
  computed: {
    modalName() {
      return `cropper-${this.uniqueID(10)}`
    },
    localStorageName() {
      return this.context.name + '_' + this.product().id
    }
  },
  async created() {
    this.searchLoading = true

    if (this.fontfamilyurl != null) {
      this.LyricFontFamilyUrl = this.fontfamilyurl
    }
    // defaul list lyric

    const ListData = await axios
      .get(`${URL_API_NEW_SEARCH_LYRIC}/suggest/${this.convertViToEn('i love you')}`)
      .then(res => {
        const data = res.data.data || []

        return data.filter(e => e.type == 'track').map(item => {
          return {
            name: item.title,
            id: item.id,
            path: item.link,
            artist_name: item.artist.name,
            data: {...item}
          }
        })
      })
      .catch(() => {
        this.searchLoading = false
      });
    // const arraydropdownData = []

    // if (ListData.length > 0) {
    //   for (var a = 0; a < ListData.length; a++) {
    //     var item_data = {
    //       name: ListData[a].track.track_name,
    //       id: ListData[a].track.track_id,
    //       path: ListData[a].track.track_name,
    //       artist_name: ListData[a].track.artist_name
    //     }
    //     arraydropdownData.push(item_data)
    //   }
    // }
    this.dropdownData = ListData
    this.searchLoading = false
  },
  data() {
    return {
      loading: false,
      imgData: '',
      dropdownData: [],
      defaultSelectText: '',
      musixApiUrl: URL_API_SEARCH_LYRIC,
      LyricMusic: null,
      messageLoading: false,
      BoxcontentMessageError: false,
      contentMessageError: '',
      trackItem: null,
      sizeCanvasLyric: {},
      isLyric: false,
      LyricFontFamily: 'fdQHAYxSad-regular',
      LyricFontFamilyUrl:
        'https://d1fajaoulwx0c1.cloudfront.net/themes/431395-heartsonglandscape3-2416/fonts/Kurale-Regular.ttf',
      ShapeLyric: null,
      colorTextLyrics: '#000000',
      OnLyric: false,
      SongDataName: null,
      TitleSong: null,
      ApiRenderLyric: URL_API_IMAGE_LYRIC,
      ChooseLyricActive: false,
      searchLoading: false
    }
  },
  methods: {
    ...mapGetters(['isSaveLocalstorage', 'product']),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    ShowBoxSearchLyric(e) {
      e.preventDefault()
      this.$modal.show(this.modalName)
    },
    ButtonApllyPrev(e) {
      e.preventDefault()
      this.OnLyric = false
    },
    GetDataItemSong(e) {
      e.preventDefault()
      const nameSong = e.target.getAttribute('data-name')
      const artistName = e.target.getAttribute('data-artist-name')
      this.SongDataName = nameSong + ' - ' + artistName
      this.TitleSong = nameSong
    },
    hideSearchLyrics(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    convertViToEn(str, toUpperCase = false) {
      str = str.toLowerCase()
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
      str = str.replace(/đ/g, 'd')
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '') // Huyền sắc hỏi ngã nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, '') // Â, Ê, Ă, Ơ, Ư

      return toUpperCase ? str.toUpperCase() : str
    },
    showLyricError() {
      this.contentMessageError = 'This song currently has no lyrics on 3rd party data, Please choose another song!';
      this.BoxcontentMessageError = true;
      this.setLoadingForm(false);
      setTimeout(() => {
        this.BoxcontentMessageError = false;
      }, 3000);
    },
    async getLyricByLRCLIB({name, artist_name}){
      try {
        const { data } = await axios.get(`${URL_API_NEW_SEARCH_LRCLIB}/api/search`, {
          params: { track_name: name, artist_name }
        });

        const lyrics = data.slice(0, 10).find(item => item.plainLyrics).plainLyrics;

        // Không có lyrics hoặc lyrics quá ngắn (≤ 1 từ)
        if (!lyrics || lyrics.trim().split(/\s+/).length <= 1) {
          return this.showLyricError();
        }

        this.LyricMusic = lyrics.replace(/[\r\n]+/g, ' ');
        this.setLoadingForm(false);
        this.OnLyric = true;
      } catch(error) {
        this.showLyricError();
      }
    },
    async ButtonApllyNext(e) {
      e.preventDefault()

      if (this.trackItem == null || this.trackItem == '') {
        this.contentMessageError = 'Please choose song!'
        this.BoxcontentMessageError = true

        const ThisOn = this

        setTimeout(function() {
          ThisOn.BoxcontentMessageError = false
        }, 1000)
      } else {
        this.setLoadingForm(true)
        // Lấy Lyric

        const [q_track, q_artist] = this.trackItem.split('&&')
        const contentLyric = await axios
          .get(`${URL_API_NEW_SEARCH_LYRIC}/v1/${encodeURIComponent(q_artist)}/${encodeURIComponent(q_track)}`)
          .then(res => {
            const lyrics = res.data.lyrics || '';
            const countWork = lyrics.trim().split(/\s+/).length
            if (countWork <= 1) {
             this.getLyricByLRCLIB({name: q_track, artist_name: q_artist});
            } else {
              this.LyricMusic = lyrics.replace(/[\r\n]+/g, " ")
              this.setLoadingForm(false)
              this.OnLyric = true
            }
          })
          .catch(() => {
            this.getLyricByLRCLIB({name: q_track, artist_name: q_artist});
          })



      }
    },
    async changeImageOnbutton(e) {
      e.preventDefault()

      if (this.LyricMusic == null) {
        this.contentMessageError = 'Please choose a song!'
        this.BoxcontentMessageError = true
        const ToThis = this
        setTimeout(function() {
          ToThis.BoxcontentMessageError = false
        }, 2000)
      } else {
        const countWord = this.LyricMusic.split(' ').length
        if (countWord < 50) {
          this.contentMessageError = 'Please enter at least 50 words!'
          this.BoxcontentMessageError = true
          const ToThis = this
          setTimeout(function() {
            ToThis.BoxcontentMessageError = false
          }, 2000)
        } else {
          this.setLoadingForm(true)
          //render image Lyric
          try {
            const urlImage = ASSET_URL + '/' + this.shapes
            const CanvasrawResponse = await fetch(this.ApiRenderLyric, {
              method: 'post',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                urlImage: urlImage,
                urlFont: this.LyricFontFamilyUrl,
                text: this.LyricMusic,
                color: this.colortextlyrics
              })
            })
            const contentCanvas = await CanvasrawResponse.json()
            const file = {
              id: this.context.name,
              key: contentCanvas.key
            }
            this.setIsSaveLocalstorage(true)
            this.context.model = file
            const dEvent = {
              id: this.lyricIdParent,
              SongName: this.TitleSong
            }
            this.setCartDataByKey({
              key: this.localStorageName,
              name: this.TitleSong,
              value: this.LyricMusic
            })
            this.$emit('ChangeTextSongLyric', dEvent)
            this.$modal.hide(this.modalName)
            this.ChooseLyricActive = true
            this.setLoadingForm(false)
          } catch (err) {
            this.setLoadingForm(false)
            this.setMessageError(true)
          }
        }
      }
    },

    async changeSelect() {
      this.searchLoading = true
      try {
        const ListData = await axios
          .get(`${URL_API_NEW_SEARCH_LYRIC}/suggest/${this.convertViToEn(this.defaultSelectText)}`)
          .then(res => {
            const data = res.data.data || []
            return data.filter(e => e.type == 'track').map(item => {
              return {
                name: item.title,
                id: item.id,
                path: item.link,
                artist_name: item.artist.name,
                data: {...item}
              }
            })
          })
          .catch(() => {
            this.searchLoading = false
          })

        // const arraydropdownData = []

        // if (ListData.length > 0) {
        //   for (var a = 0; a < ListData.length; a++) {
        //     var item_data = {
        //       name: ListData[a].track.track_name,
        //       id: ListData[a].track.track_id,
        //       path: ListData[a].track.track_name,
        //       artist_name: ListData[a].track.artist_name
        //     }
        //     arraydropdownData.push(item_data)
        //   }
        // }
        this.dropdownData = ListData
        this.searchLoading = false
      } catch (error) {
        this.searchLoading = false
      }
    },
    hideModal(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      return { key: signedUrl.key }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style scoped>
.btn-icon-search-lyric {
  width: 45px;
  height: 35px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2a2a2a;
  color: #fff;
  cursor: pointer;
  border-radius: 5px;
  margin-left: 5px;
}

.btn-icon-search-lyric.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.box-search-song {
  border: 1px solid #ced4da;
  padding: 2px;
  margin: 10px 0 !important;
  border-radius: 0.25rem;
}

.box-search-song {
  display: flex;
  align-items: center;
  justify-content: center;
}
.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

.btn-add-to-cart {
  display: block;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.Abn-flex-button-cart {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.Abn_box_form_lyrics {
  margin-bottom: 20px;
}

.btn-preview {
  border: 1px solid #999;
  margin: 2px;
  width: 100%;
}
.modal-close {
  position: absolute;
  top: 5px;
  right: 5px;
  border: 1px solid #ff7875;
  width: 30px;
  height: 30px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
}

.hdev-row-float {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: nowrap;
  flex-direction: row;
  margin-bottom: 5px;
  cursor: pointer;
}
.button_search_lyric {
  transition: 0.6s;
  text-decoration: underline;
  color: #084298;
}

.form-select-search-lyric {
  width: 100%;
}

.list_track_item {
  cursor: pointer;
  margin: 10px 0;
  display: flex;
  align-items: baseline;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: stretch;
  justify-content: flex-start;
}
.list_track_item * {
  cursor: pointer;
  width: 100%;
  float: left;
}

.list_track_item input {
  margin-right: 5px;
  display: none;
}

.list_track_group input[type='radio']:checked ~ label {
  color: #f6f6f6;
  background: none 0% 0% / auto repeat scroll padding-box border-box #dc3545;
  width: 99% !important;
  padding: 5px !important;
  border-radius: 3px !important;
}

.list_track_group input[type='radio']:checked ~ label::before {
  content: '\266B ' !important;
}

.list_track_item:hover {
  color: darkblue !important;
}

.list_track_group {
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 150px !important;
  overflow: auto !important;
}

p.modal-body-header-title1 {
  line-height: 1.2 !important;
  text-align: center !important;
  font-size: 14px !important;
  margin: 0 !important;
}

p.modal-body-header-title2 {
  text-align: center !important;
  color: #9e0000 !important;
  line-height: 1.2 !important;
  margin: 0 !important;
  font-weight: 600 !important;
}

.Abn-modal-footer {
  text-align: right !important;
  margin: 7px 0 !important;
  width: 100% !important;
  float: left;
  padding-bottom: 10px;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box
    rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 100%;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
}

input.form-select-search-lyric.form-control {
  /* margin: 10px 0 !important; */
  border: none;
  box-shadow: none;
  height: 35px;
}

.list_track_group::-webkit-scrollbar-thumb {
  background-color: #001a5c !important;
}

.list_track_group::-webkit-scrollbar {
  width: 6px !important;
  background-color: #f5f5f5 !important;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 99999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}

.message-text {
  background: white !important;
  width: 400px !important;
  margin: auto !important;
  padding: 10px !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  border-radius: 7px !important;
  color: #4c4e4e !important;
}

.message-error-left-group {
  position: fixed !important;
  top: 10px !important;
  right: 10px !important;
  background: #0dcaf0 !important;
  padding: 5px 25px !important;
  border-radius: 10px 0px 10px 10px !important;

  z-index: 9999999999999999 !important;
}

.message-error-left-group {
  color: white !important;
  font-weight: 500 !important;
}

.Abn-modal-content {
  padding: 15px 20px !important;
}

.Abn-modal-header {
  padding: 5px 0 !important;
  border-bottom: 1px solid #d7d7db !important;
  margin: 10px 0 !important;
}

.Abn-lyric-text {
  margin: 7px 0;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.NoneSearch {
  display: none !important;
}
.Abn-modal-footer {
  display: flex;
}
.Abn-modal-footer > button {
  flex: 1;
  text-align: center;
  margin: 5px;
  cursor: pointer;
}
.Abn-admin_name_lyric {
  font-weight: 500;
  color: #9e0000 !important;
  text-transform: capitalize;
}

.red-text-label {
  color: #f30404;
}

.v-ion-abn {
  width: 16px;
  padding: 0;
  margin: 0;
}

.choose_lyric_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

@keyframes animation_button_active {
  from {
    opacity: 0.1;
  }
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageLyrics.vue